<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup search employee
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from '@/utils/repository';
import { mapState } from 'vuex';
/**
 * Import template
 */
import template from './template.html';
import './style.scss';

/**
 * Define component chat for show page chat
 */
var PopupSearchEmployees = {
    template: template,
    props: {
        onSelected: Function,
        onClose: Function
    },
    data() {
        return {
            search: '',
            searching: false,
            resultSearch: null,
            isRetired: '0',
            paging: {
                totalRecord: 5,
                record: '',
                page: 1,
                maxpage: 1
            }
        };
    },
    computed: {
        ...mapState('app', ['isMobile'])
    },
    watch: {
        resultSearch() {
            setTimeout(() => {
                this.onResizeWindow();
            }, 0);
        }
    },
    mounted() {
        setTimeout(() => {
            this.$refs.inputSearch?.focus();
        }, 500);
    },
    methods: {
        doSearch(page = 1) {
            if (this.searching) {
                return;
            }
            this.searching = true;
            repository
                .get(`common/search/employees`, {
                    params: {
                        p002: this.search,
                        p003: page,
                        p004: this.isRetired
                    }
                })
                .then((res) => {
                    this.searching = false;
                    const { data } = res;
                    if (data.Code === 200) {
                        this.resultSearch = data.Data.employees;
                        this.paging = data.Data.paging;
                    } else {
                        this.resultSearch = [];
                    }
                });
        },
        selectRow(item) {
            if (this.onSelected) {
                this.onSelected(item);
            }
            this.onClose();
        },
        onResizeWindow() {
            // eslint-disable-next-line no-undef
            const tableWidth = $('#table-emp').innerWidth() - 24;
            // eslint-disable-next-line no-undef
            $('#table-emp .col_1').css({
                width: `${tableWidth * 0.15}px`,
                'min-width': `${tableWidth * 0.15}px`,
                'max-width': `${tableWidth * 0.15}px`
            });
            // eslint-disable-next-line no-undef
            $('#table-emp .col_2').css({
                width: `${tableWidth * 0.25}px`,
                'min-width': `${tableWidth * 0.25}px`,
                'max-width': `${tableWidth * 0.25}px`
            });
            // eslint-disable-next-line no-undef
            $('#table-emp .col_3').css({
                width: `${tableWidth * 0.3}px`,
                'min-width': `${tableWidth * 0.3}px`,
                'max-width': `${tableWidth * 0.3}px`
            });
            // eslint-disable-next-line no-undef
            $('#table-emp .col_4').css({
                width: `${tableWidth * 0.3}px`,
                'min-width': `${tableWidth * 0.3}px`,
                'max-width': `${tableWidth * 0.3}px`
            });
        }
    }
};
export default PopupSearchEmployees;
</script>
